import { createContext, useContext } from 'react';

export interface MaintenancePreviewMountState {
  active: boolean;
  screenId?: string;
  route?: string;
}

export const MaintenancePreviewMountContext = createContext<MaintenancePreviewMountState>({
  active: false,
});

export function useMaintenancePreviewMount(): MaintenancePreviewMountState {
  return useContext(MaintenancePreviewMountContext);
}
